{
  "de": {
    "pageTitle": "Vinyl-Suche",
    "pageSubtitle": "Schallplatten, LPs, Singles & mehr – direkt durchsuchen",
    "searchPlaceholder": "Titel, Artist, Trackliste ...",
    "exampleLabel": "z.B.:",
    "statsNoResults": "Keine Treffer",
    "statsOneResult": "1 Treffer",
    "statsManyResults": "{n} Treffer",
    "statsTiming": "in {ms}ms",
    "noResultsText": "Keine Treffer für \"{q}\". Versuch einen anderen Suchbegriff.",
    "loadMoreButton": "Mehr laden",
    "filterToggleButton": "Filter",
    "filterFormat": "Format",
    "filterCoverGrade": "Cover-Zustand",
    "filterVinylGrade": "Vinyl-Zustand",
    "filterGenre": "Genre",
    "filterPrice": "Preis",
    "filterPriceAll": "Alle Preise",
    "filterPriceUpTo5": "bis 5 EUR",
    "filterPrice5to15": "5 – 15 EUR",
    "filterPrice15to30": "15 – 30 EUR",
    "filterPrice30to50": "30 – 50 EUR",
    "filterPrice50to100": "50 – 100 EUR",
    "filterPriceOver100": "über 100 EUR",
    "sortRelevance": "Relevanz",
    "sortArtistAsc": "A – Z (Artist)",
    "sortPriceAsc": "Niedrigster Preis",
    "sortPriceDesc": "Höchster Preis",
    "refinementFormat": "Format",
    "refinementCover": "Cover",
    "refinementVinyl": "Vinyl",
    "refinementGenre": "Genre",
    "refinementPrice": "Preis",
    "fieldSku": "SKU",
    "fieldPrice": "Preis",
    "selectButton": "Auswählen",
    "showMore": "mehr anzeigen",
    "showLess": "weniger",
    "browsePlaceholder": "Gib einen Suchbegriff ein oder wähle einen Filter."
  },
  "en": {
    "pageTitle": "Vinyl Search",
    "pageSubtitle": "Records, LPs, Singles & more – search directly",
    "searchPlaceholder": "Title, artist, tracklist ...",
    "exampleLabel": "e.g.:",
    "statsNoResults": "No results",
    "statsOneResult": "1 result",
    "statsManyResults": "{n} results",
    "statsTiming": "in {ms}ms",
    "noResultsText": "No results for \"{q}\". Try a different search term.",
    "loadMoreButton": "Load more",
    "filterToggleButton": "Filter",
    "filterFormat": "Format",
    "filterCoverGrade": "Cover Condition",
    "filterVinylGrade": "Vinyl Condition",
    "filterGenre": "Genre",
    "filterPrice": "Price",
    "filterPriceAll": "All prices",
    "filterPriceUpTo5": "up to EUR 5",
    "filterPrice5to15": "EUR 5 – 15",
    "filterPrice15to30": "EUR 15 – 30",
    "filterPrice30to50": "EUR 30 – 50",
    "filterPrice50to100": "EUR 50 – 100",
    "filterPriceOver100": "EUR 100+",
    "sortRelevance": "Relevance",
    "sortArtistAsc": "A – Z (Artist)",
    "sortPriceAsc": "Lowest price",
    "sortPriceDesc": "Highest price",
    "refinementFormat": "Format",
    "refinementCover": "Cover",
    "refinementVinyl": "Vinyl",
    "refinementGenre": "Genre",
    "refinementPrice": "Price",
    "fieldSku": "SKU",
    "fieldPrice": "Price",
    "selectButton": "Select",
    "showMore": "show more",
    "showLess": "show less",
    "browsePlaceholder": "Enter a search term or select a filter."
  }
}
